import { createSlice } from "@reduxjs/toolkit";
import * as BrandingSubmissionApi from "../api/branding-submission";

const brandingSubmissionDetail = createSlice({
  name: "brandingSubmissionDetail",
  initialState: {
    loading: false,
    error: null,
    submission: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getDetailSuccess: (state, action) => {
      state.submission = action.payload;
      state.loading = false;
    },
  },
});

export const getBrandingSubmissionDetail = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await BrandingSubmissionApi.getBrandingSubmissionById(id);
    dispatch(getDetailSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = brandingSubmissionDetail;
export const { setLoading, setError, getDetailSuccess } = actions;
export default reducer;
